import { render, staticRenderFns } from "./JudgeListAfterLayout.vue?vue&type=template&id=a542269a&scoped=true"
import script from "./JudgeListAfterLayout.vue?vue&type=script&lang=js"
export * from "./JudgeListAfterLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a542269a",
  null
  
)

export default component.exports